<template>
  <v-container fluid>
    <v-card>
      <v-toolbar dense style="background:#F5F5F5">
        <v-toolbar-title dense style="color:#607D8B;font-weight:bold">Absences justifiées</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="refresh" icon>
          <v-icon color="#009688" large>mdi-refresh</v-icon>
          <template v-slot:loader>
            <span class="custom-loader"> <v-icon light>cached</v-icon></span>
          </template>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-dialog fullscreen v-model="loading">
          <v-container fill-height fluid style="background-color: rgba(200, 200, 200, 0.5);">
            <v-layout align-center="true" justify-center="true">
              <v-progress-circular
                  :on-cancel="onCancel"
                  :size="70"
                  color="#009688"
                  indeterminate>
              </v-progress-circular>
            </v-layout>
          </v-container>
        </v-dialog>
        <v-alert :color=AlertColor(type)
                 :dismissible=true
                 :value=true
                 @input="dismissible_close"
                 border="top"
                 class="pre-formatted multi-line"
                 colored-border
                 elevation="2"
                 icon="check_circle"
                 style="color: #546E7A"
                 v-if="type">
          {{ text }}
        </v-alert>
        <v-card class="mt-1" flat
                tile>
          <v-row>
            <v-col>
              <v-select :items="selectDates" @change="depthDate" dense filled full-width
                        hide-details="true"
                        item-text="name"
                        item-value="value" return-object solo style="z-index: 200"
                        v-model="depthVal">
                <template v-slot:selection="{ item }">
                                      <span class="d-flex justify-center" style="width: 100%;">
                                        {{ item.name }}
                                      </span>
                </template>
              </v-select>
            </v-col>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col>
              <v-text-field :id="dynamicID()"
                            @change="search"
                            @keyup.native.enter="search"
                            @click:clear="cleared()"
                            append-icon="mdi-magnify"
                            class="centered-input align-center"
                            clearable
                            hide-details
                            placeholder="Recherche"
                            v-model="searchName">
              </v-text-field>
            </v-col>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col>
              <v-btn @click="onexportNbrAbsences" block class="custom-btn white--text" color="#03A9F4"
                     height="45px"
                     large>
                <v-icon class="mr-1">mdi-file-export-outline</v-icon>
                <span>Export (Thalia)</span>
              </v-btn>
            </v-col>
            <v-col>
              <v-btn @click="onexport" block class="custom-btn white--text" color="#00BCD4" height="45px" large>
                <v-icon class="mr-1">mdi-file-excel-outline</v-icon>
                <span>Export rapport</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
        <v-card class="mt-4"
                elevation="6">
          <hot-table :settings="hotSettings" ref="hotTable"></hot-table>
        </v-card>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import {HotTable} from "@handsontable/vue";
import "handsontable/languages/fr-FR";
import moment from "moment"
import "vue-loading-overlay/dist/vue-loading.css";
import {depthDate} from "../../../helper/profondeur";
import * as XLSX from 'xlsx';
import Handsontable from "handsontable";
import apiClient from '../../../config/api';


function cellProblemRenderer(hotInstance, td, row, column, prop, value, cellProperties) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  td.className = "colProblem";
}

function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

export default {
  name: "AbsencesJustifiees",
  components: {HotTable},
  data: function () {
    return {
      isMobile: isMobileDevice(),
      disableMainBtn: false,
      searchName: "",
      type: null,
      elapse: null,
      lastHighlitedRow: null,
      loading: false,
      selectDates: depthDate,
      depthVal: {
        name: sessionStorage.getItem("depthValChoosedt"),
        value: sessionStorage.getItem("depthValChoosedd")
      },
      fullPage: false,
      text: "",
      color: "",
      toObject: [],
      hotSettings: {
        renderAllRows: false,          // Rendu virtuel
        viewportRowRenderingOffset: 'auto',  // Calcul dynamique
        data: [],
        colWidths: 100,
        width: "100%",
        height: "675px",
        fixedRowsTop: 0,
        columnSorting: true,
        sortIndicator: true,
        filters: true,
        dropdownMenu: ["filter_by_condition", "filter_action_bar", "filter_operators", "filter_by_value"],
        licenseKey: "non-commercial-and-evaluation",
        stretchH: "all",
        selectionMode: "single",
        minSpareRows: false,
        language: "fr-FR",
        customBorders: true,
        columnHeaders: true,
        rowHeaders: true,
        stretch: "all",
        className: "htCenter htMiddle",
        manualColumnResize: true,
        readOnly: true,
        afterFilter: this.afterFilter,
        afterLoadData: this.afterLoadData,
        currentRowClassName: 'rowHighlight',
        hiddenColumns: {
          columns: [8],
          indicators: false
        },
        colHeaders: [
          "Matricule", "Nom", "Prénom", "Brigade", "Nom Shift", "Date début", "Date fin", "EnCours",
          "Plannifiée", "Raison absence", "Observations", "Date création", "Matricule créateur"
        ],
        columns: [
          {title: "Matricule", width: "150px"},
          {title: "Nom", width: "160px"},
          {title: "Prénom", width: "200px"},
          {title: "Brigade", width: "160px"},
          {title: "Nom Shift", width: "160px"},
          {
            title: "Date début",
            width: "180px",
            type: "date",
            dateFormat: "DD-MM-YYYY",
            correctFormat: true
          },
          {
            title: "Date fin",
            width: "180px",
            type: "date",
            dateFormat: "DD-MM-YYYY",
            correctFormat: true
          },
          {title: "EnCours", width: "120px", type: "checkbox"},
          {title: "Plannifiée", width: "120px", type: "checkbox"},
          {title: "Raison absence", width: "300px"},
          {title: "Observations", width: "180px"},
          {
            title: "Date création",
            width: "180px",
            dateFormat: "DD-MM-YYYY HH:mm:ss",
            correctFormat: true,
            type: "date",
            readOnly: true
          },
          {title: "Matricule créateur", width: "160px"}
        ],
        cells: function (row, col, prop) {
          const cellProperties = {};

          if (col === 0) {
            const cellValue = this.instance.getSourceDataAtCell(row, 10);
            if (cellValue === "Présence constatée") {
              cellProperties.renderer = cellProblemRenderer;
            }
          }

          return cellProperties;
        }
      }
    }
  },

  created() {
    this.depthDate()
  },

  methods: {
    cleared() {
      this.searchName = "";
      this.getData();
    },
    search() {
      var query = this.isEmpty(this.searchName) ? this.searchName : this.searchName.toLowerCase()

      if (this.isEmpty(query)) {
        this.cleared()
      }

      var row;
      var col;
      var rLen;
      var cLen;
      var data = this.$refs.hotTable.hotInstance.getData();
      var array = [];
      for (row = 0, rLen = data.length; row < rLen; row++) {
        for (col = 0, cLen = Object.keys(data[row]).length; col < cLen; col++) {
          var x = Object.keys(data[row])[col];
          if (('' + data[row][x]).toLowerCase().indexOf(query) > -1) {
            array.push(data[row]);
            break;
          }
        }
      }
      this.$refs.hotTable.hotInstance.loadData(array);
    },
    dynamicID() {
      return 'dynamicID-' + Math.floor(Math.random() * Date.now().toString());
    },
    afterSelectionEnd(r, c) {
      var i;
      if (this.lastHighlitedRow !== null) {
        for (i = 0; i < this.$refs.hotTable.hotInstance.countCols(); i++) {
          this.$refs.hotTable.hotInstance.setCellMeta(this.lastHighlitedRow, i, 'className', 'htCenter htMiddle');
        }
      }

      for (i = 0; i < this.$refs.hotTable.hotInstance.countCols(); i++) {
        this.$refs.hotTable.hotInstance.setCellMeta(r, i, 'className', 'area highlight, htCenter htMiddle');
      }
      this.lastHighlitedRow = r;

      this.$refs.hotTable.hotInstance.render()
    },
    depthDate() {
      if (this.depthVal) {
        sessionStorage.setItem("depthValChoosedd", this.depthVal.value)
        sessionStorage.setItem("depthValChoosedt", this.depthVal.name)
      }
      this.getData(this.depthVal)
    },
    isEmpty(str) {
      return (!str || 0 === str.length || /^\s*$/.test(str));
    },
    async getData(valeur) {
      this.loading = true
      valeur = this.depthVal.value

      try {
        const response = await apiClient.get(
            `${this.$store.getters.user.baseUrl}/reports/absencesreportbydatedepth/` + moment().subtract(valeur, "days").format("YYYY-MM-DD") + "/" + sessionStorage.getItem("userId")
        );

        this.loading = false
        let tabArray = []
        let newObj = response.data.datas;

        if (response.data.status !== 200) {
          this.color = "#009688"
          this.text = response.data.message;
          this.showAlert('warning')
          this.disableMainBtn = true
        } else {
          this.disableMainBtn = false
        }

        String.prototype.capitalize = function (allWords) {
          return (allWords) ? // if all words
              this.split(' ').map(word => word.capitalize()).join(' ') : //break down phrase to words then  recursive calls until capitalizing all words
              this.charAt(0).toUpperCase() + this.slice(1); // if allWords is undefined , capitalize only the first word , mean the first char of the whole string
        }

        newObj.forEach((item) => {
          tabArray.push([
            item["userId"],
            this.isEmpty(item["accountLastname"]) ? "" : item["accountLastname"].toUpperCase(),
            this.isEmpty(item["accountFirstname"]) ? "" : item["accountFirstname"].toLowerCase().capitalize(true),
            this.isEmpty(item["brigade"]) ? "" : item["brigade"].toUpperCase(),
            item["shiftName"],
            moment(item["startDate"], "YYYY-MM-DD").format("DD-MM-YYYY"),
            moment(item["endDate"], "YYYY-MM-DD").format("DD-MM-YYYY"),
            item["onGoing"],
            item["plannifiee"],
            item["reasonAbsence"],
            item["absenceObservations"],
            item["creationDate"] !== null ? moment(item["creationDate"]).format("DD-MM-YYYY HH:mm:ss") : "",
            item["originUser"]
          ])
        })

        this.$refs.hotTable.hotInstance.loadData(tabArray)
        this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()];

      } catch (err) {
        if (err.code === 'ECONNABORTED') {
          this.error = "La requête a pris trop de temps. Veuillez réessayer.";
        } else {
          this.error = "Une erreur s'est produite: " + (err.response?.data?.message || err.message);
        }
        console.error('Erreur API:', err);
        this.loading = false
      } finally {
        this.loading = false;
      }
    },
    onCancel() {
      this.loading = false
    },
    refresh() {
      this.getData(this.depthVal)
    },
    afterLoadData() {
      this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()];
    },
    afterFilter() {
      this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()];
    },
    AlertColor(type) {
      return type === "info" ? "#4CAF50" : "#F44336";
    },
    showAlert(type) {
      this.type = type

      let timer = this.showAlert.timer
      if (timer) {
        clearTimeout(timer)
      }
      this.showAlert.timer = setTimeout(() => {
        this.type = null
      }, 20000)

      this.elapse = 1
      let t = this.showAlert.t
      if (t) {
        clearInterval(t)
      }

      this.showAlert.t = setInterval(() => {
        if (this.elapse === 3) {
          this.elapse = 0
          clearInterval(this.showAlert.t)
        } else {
          this.elapse++
        }
      }, 5000)
    },
    dismissible_close() {
      this.elapse = 3
      clearTimeout(this.showAlert.timer)
      clearInterval(this.showAlert.t)
      this.type = null
    },
    onexport() { // On Click Excel download button
      // export json to Worksheet of Excel
      // only array possible
      this.loading = true
      var datas = XLSX.utils.json_to_sheet(this.toObject, {skipHeader: true})
      // var pokemonWS = XLSX.utils.json_to_sheet(this.Datas.pokemons)

      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new() // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, datas, "Absences_justifiées") // sheetAName is name of Worksheet
      // XLSX.utils.book_append_sheet(wb, pokemonWS, "pokemons")

      // export Excel file
      XLSX.writeFile(wb, "Absences_justifiées.xlsx") // name of the file is "book.xlsx"
      this.loading = false
    },

    pad(n, width, z) {
      z = z || '0';
      n = n + '';
      return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    },

    onexportNbrAbsences() { // On Click Excel download button
      class Counter extends Map {
        constructor(iter, key = null) {
          super();
          this.key = key || (x => x);
          for (let x of iter) {
            this.add(x);
          }
        }

        add(x) {
          x = this.key(x);
          this.set(x, (this.get(x) || 0) + 1);
        }
      }

      var resultCA = this.toObject.filter((x) => {
        return x[9] === 'Congés annuels'
      });
      var resultMNP = this.toObject.filter((x) => {
        return x[9] === 'Maladie'
      });
      var resultPERM = this.toObject.filter((x) => {
        return x[9] === 'Permission'
      });
      var resultCEF = this.toObject.filter((x) => {
        return x[9] === 'Permission exceptionnelle'
      });
      var resultMAP = this.toObject.filter((x) => {
        return x[9] === 'Mise à pied'
      });
      var resultRC = this.toObject.filter((x) => {
        return x[9] === 'Repos compensateur'
      });

      //console.log("Résultat avec doublons : " + result);
      var uniqueCA = resultCA.filter((item, pos, self) => self.findIndex(v => v[0] === item[0]) === pos);
      var uniqueMNP = resultMNP.filter((item, pos, self) => self.findIndex(v => v[0] === item[0]) === pos);
      var uniquePERM = resultPERM.filter((item, pos, self) => self.findIndex(v => v[0] === item[0]) === pos);
      var uniqueCEF = resultCEF.filter((item, pos, self) => self.findIndex(v => v[0] === item[0]) === pos);
      var uniqueMAP = resultMAP.filter((item, pos, self) => self.findIndex(v => v[0] === item[0]) === pos);
      var uniqueRC = resultRC.filter((item, pos, self) => self.findIndex(v => v[0] === item[0]) === pos);
      //console.log("Résultat sans doublons : " + unique);

      let byMatCA = new Counter(resultCA, x => x[0]);
      let byMatMNP = new Counter(resultMNP, x => x[0]);
      let byMatPERM = new Counter(resultPERM, x => x[0]);
      let byMatCEF = new Counter(resultCEF, x => x[0]);
      let byMatMAP = new Counter(resultMAP, x => x[0]);
      let byMatRC = new Counter(resultRC, x => x[0]);
      //console.log("byMat", byMat);

      var datasTmpCA = []
      var datasTmpMNP = []
      var datasTmpPERM = []
      var datasTmpCEF = []
      var datasTmpMAP = []
      var datasTmpRC = []

      var i = 0
      let sommeCA = 0
      for (var [clefCA, valeurCA] of byMatCA) {
        datasTmpCA.push([
          this.pad(clefCA, 3),
          uniqueCA[i][1] + " " + uniqueCA[i][2],
          valeurCA
        ])
        sommeCA += valeurCA
        ++i;
      }
      datasTmpCA.push([
        "",
        "",
        ""
      ])
      datasTmpCA.push([
        "",
        "Total",
        sommeCA
      ])

      i = 0
      let sommeMNP = 0
      for (var [clefMNP, valeurMNP] of byMatMNP) {
        datasTmpMNP.push([
          this.pad(clefMNP, 3),
          uniqueMNP[i][1] + " " + uniqueMNP[i][2],
          valeurMNP
        ])
        sommeMNP += valeurMNP
        ++i;
      }
      datasTmpMNP.push([
        "",
        "",
        ""
      ])
      datasTmpMNP.push([
        "",
        "Total",
        sommeMNP
      ])

      i = 0
      let sommePERM = 0
      for (var [clefPERM, valeurPERM] of byMatPERM) {
        datasTmpPERM.push([
          this.pad(clefPERM, 3),
          uniquePERM[i][1] + " " + uniquePERM[i][2],
          valeurPERM
        ])
        sommePERM += valeurPERM
        ++i;
      }
      datasTmpPERM.push([
        "",
        "",
        ""
      ])
      datasTmpPERM.push([
        "",
        "Total",
        sommePERM
      ])

      i = 0
      let sommeCEF = 0
      for (var [clefCEF, valeurCEF] of byMatCEF) {
        datasTmpCEF.push([
          this.pad(clefCEF, 3),
          uniqueCEF[i][1] + " " + uniqueCEF[i][2],
          valeurCEF
        ])
        sommeCEF += valeurCEF
        ++i;
      }
      datasTmpCEF.push([
        "",
        "",
        ""
      ])
      datasTmpCEF.push([
        "",
        "Total",
        sommeCEF
      ])

      i = 0
      let sommeMAP = 0
      for (var [clefMAP, valeurMAP] of byMatMAP) {
        datasTmpMAP.push([
          this.pad(clefMAP, 3),
          uniqueMAP[i][1] + " " + uniqueMAP[i][2],
          valeurMAP
        ])
        sommeMAP += valeurMAP
        ++i;
      }
      datasTmpMAP.push([
        "",
        "",
        ""
      ])
      datasTmpMAP.push([
        "",
        "Total",
        sommeMAP
      ])

      i = 0
      let sommeRC = 0
      for (var [clefRC, valeurRC] of byMatRC) {
        datasTmpRC.push([
          this.pad(clefRC, 3),
          uniqueRC[i][1] + " " + uniqueRC[i][2],
          valeurRC
        ])
        sommeRC += valeurRC
        ++i;
      }
      datasTmpRC.push([
        "",
        "",
        ""
      ])
      datasTmpRC.push([
        "",
        "Total",
        sommeRC
      ])

      datasTmpCA = [["Matricule", "Nom & Prénom", "Congés annuels"], ...datasTmpCA];
      datasTmpMNP = [["Matricule", "Nom & Prénom", "Maladie"], ...datasTmpMNP];
      datasTmpPERM = [["Matricule", "Nom & Prénom", "Permission"], ...datasTmpPERM];
      datasTmpCEF = [["Matricule", "Nom & Prénom", "Permission exceptionnelle"], ...datasTmpCEF];
      datasTmpMAP = [["Matricule", "Nom & Prénom", "Mise à pied"], ...datasTmpMAP];
      datasTmpRC = [["Matricule", "Nom & Prénom", "Repos compensateur"], ...datasTmpRC];
      //console.log("Résultat final -> ", datasTmp);

      var datasCA = XLSX.utils.json_to_sheet(datasTmpCA, {origin: 'A1', skipHeader: true})
      var datasMNP = XLSX.utils.json_to_sheet(datasTmpMNP, {origin: 'A1', skipHeader: true})
      var datasPERM = XLSX.utils.json_to_sheet(datasTmpPERM, {origin: 'A1', skipHeader: true})
      var datasCEF = XLSX.utils.json_to_sheet(datasTmpCEF, {origin: 'A1', skipHeader: true})
      var datasMAP = XLSX.utils.json_to_sheet(datasTmpMAP, {origin: 'A1', skipHeader: true})
      var datasRC = XLSX.utils.json_to_sheet(datasTmpRC, {origin: 'A1', skipHeader: true})

      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new() // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, datasCA, "Congés annuels") // sheetAName is name of Worksheet
      XLSX.utils.book_append_sheet(wb, datasMNP, "Maladie") // sheetAName is name of Worksheet
      XLSX.utils.book_append_sheet(wb, datasPERM, "Permission") // sheetAName is name of Worksheet
      XLSX.utils.book_append_sheet(wb, datasCEF, "Permission exceptionnelle") // sheetAName is name of Worksheet
      XLSX.utils.book_append_sheet(wb, datasMAP, "Mise à pied") // sheetAName is name of Worksheet
      XLSX.utils.book_append_sheet(wb, datasRC, "Repos compensateur") // sheetAName is name of Worksheet
      // XLSX.utils.book_append_sheet(wb, pokemonWS, "pokemons")

      // export Excel file
      XLSX.writeFile(wb, "Export_Thalia_Absences_Justifiées.xlsx") // name of the file is "book.xlsx"
      this.loading = false
    }
  }
};
</script>

<style>
.toolbar .v-toolbar__content {
  padding: 0 !important
}

.input-class {
  padding: 2px 0;
  border-bottom: solid 1px #999;
  color: #444;
  width: 100%;
}

.v-text-field {
  min-width: 222px;
}

.custom-btn {
  width: 222px;
}

.custom-btn::before {
  color: transparent
}

.custom-btn:hover {
  color: #F5F5F5 !important;
}

.handsontable .yellow {
  background-color: #faec8f;
}

.colProblem {
  text-align: center;
  background-color: yellow !important;
  font-weight: bold !important;
  font-style: normal !important;
}
</style>